export default __webpack_public_path__ + "static/media/undraw-login.63f81b78.png";